import { useContext } from "react";
import { ObjectContext } from "@providers/ObjectProvider";
import Table from '@mui/joy/Table';
import Stack from '@mui/joy/Stack';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import Typography from '@mui/joy/Typography';
import { gradientTint } from "@utils/gradientTint";
import { sortByDate } from "@utils/sorters";
import { formatDate } from "@utils/dates";
import { DynamicControl } from "@components/forms/DynamicControl";
import { columnNameToLabel, titleCase } from "@utils/strings";
import { Controller, useFormContext } from "react-hook-form";
import SearchSelect from "@components/SearchSelect";

const TbodyWrapper = ({mode, children}) => (<>
  {mode === 'row' && <tbody>{children}</tbody>}
  {mode === 'column' && <tbody><tr>{children}</tr></tbody>}
</>);

export function FieldEditTable({
    fields = [],
    mode = 'row',
    // ...restProps
}) {
    // const data = useContext(ObjectContext);
    const { getValues, setValue, register, control, watch } = useFormContext();

    return (
      <Table
        stripe="odd"
        sx={{
          margin: 0,
          padding: 0,
          tableLayout: 'auto',
        }}
      >
      {mode === 'column' && (
        <thead>
          <tr>
            {fields.map((header, headerIndex) => {
              const label = typeof header.label === 'undefined' ? columnNameToLabel(header.name) : header.label;
              return (<th key={headerIndex}>{label}</th>)
            })}
          </tr>
        </thead>
      )}
        <TbodyWrapper mode={mode}>
        {/* <tbody> */}
        {fields.map((row, rowIndex) => {
          if(row.hasOwnProperty('conditional')) {
            if(typeof row.conditional === 'boolean' && typeof row.content !== 'string') {
                return <em>row content cannot be a function with a simple truthy conditional</em>
            }

            // general truthy check
            if(
                typeof row.conditional === 'boolean'
                && row.conditional === true
                && !getValues(row.content)
            ) {
                return null;
            }

            // fn truthy check
            if(
                typeof row.conditional === 'function'
                && row.conditional(watch()) !== true
            ) {
                return null;
            }
          }

          const label = typeof row.label === 'undefined' ? columnNameToLabel(row.name) : row.label;

          // asterisks are handled this way to keep the layout from shifting
          const hasAsterisk = !!(row?.config?.required) || row.hasOwnProperty('showRequired');
          const showAsterisk = !!(row?.config?.required) || row.hasOwnProperty('showRequired') && row.showRequired(getValues());

          if(mode === 'column') {
            return (
              <td key={rowIndex}>
                {row.type !== 'info' && (<DynamicControl {...row} />)}
                {typeof row.content === 'function' ? row.content(watch(), setValue) : row.content}
              </td>
            )
          }

          return (
            <tr key={rowIndex}>
              {row.label !== false && (
                <td className="min">
                  {/* <label htmlFor={row.name}>{row.label}</label> */}
                  <Typography
                    component={'label'}
                    htmlFor={row.name}
                    fontSize={'sm'}
                    fontWeight={'bold'}
                  >
                    {label}{hasAsterisk && <Typography color="danger" fontSize={'xs'} sx={{position: 'relative', left: '.13rem', top: '-0.25rem', opacity: showAsterisk ? 1 : 0}}>*</Typography>}
                  </Typography>
                </td>
              )}
              <td className="max" colSpan={row.label !== false ? 1 : 2}>
                {row.type !== 'info' && (<DynamicControl {...row} />)}
                {typeof row.content === 'function' ? row.content(watch(), setValue) : row.content}
              </td>
            </tr>
          )
        })}
        {/* </tbody> */}
        </TbodyWrapper>
      </Table>
  );
}
